<template>
    <div class="modal fade in" id="ModalAssinar">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <p class="modal-title"><i class="fa fa-pencil"></i> Assinar documento {{file.arquivo_nome}}</p>
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                </div>
                <div class="modal-body">
                    <div class="row" v-if="requireDocument">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label :class="{ 'text-danger': errors.has('Documento') }"><i
                                        class="fa fa-list-alt"></i> CPF</label>
                                <input v-mask="'###.###.###-##'" v-validate="{required: true, document: true}"
                                    :class="{ 'is-invalid': errors.has('Documento') }" class="form-control"
                                    name="Documento" v-model="request.assinatura_documento" placeholder="Documento">
                                <div class="invalid-feedback help-block error">{{errors.first('Documento')}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <token-otp ref="inputOtp" @changed="setToken">
                                </token-otp>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="callout callout-warning">
                                <h6><b><i class="fa fa-exclamation-triangle"></i></b>
                                    O documento será assinado SEM uso do certificado digital próprio.</h6>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" data-dismiss="modal" class="btn btn-default float-left"><i
                            class="fa fa-times"></i>
                        {{ $t('words.cancel')}}</button>
                    <button type="button" id="signButton" :disabled="loading || !request.token_otp" @click="sign()"
                        class="btn btn-success float-right"><i class="fa fa-check"></i>
                        Assinar <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TokenOtp from '../token-otp.vue';
    export default {
        components: {
            TokenOtp
        },
        props: {
            requireDocument: Boolean,
            tokenTipo: String,
        },
        data() {
            return {
                loading: false,
                file: {},
                request: {
                    signature: null,
                    assinatura_documento: '',
                    token_otp: null,
                }
            }
        },
        methods: {
            setToken(payload) {
                this.request.token_otp = payload;
            },
            sign() {
                this.$validator.validateAll().then(valid => {
                    if (!valid) {
                        return;
                    }
                    this.loading = true;
                    this.request.signature = this.$route.params.id;
                    this.$store.dispatch('signWithoutCertPublic', this.request).then(response => {
                        toastr({
                            title: response.message,
                            icon: response.status
                        });
                        $('#ModalAssinar').modal('toggle');
                        setTimeout(() => {
                            this.$router.push(`/validador?arquivo=${this.file.id}`);
                        }, 500)
                    }).catch(error => {
                        toastr({
                            title: error.message,
                            icon: error.status
                        });
                    }).finally(() => {
                        this.loading = false;
                    });
                });
            }
        }
    }
</script>